import {Box, Typography} from "@mui/material";
import {CalendarMonth} from "@mui/icons-material";
import React from "react";

import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation, A11y } from "swiper/modules";
import ProgressIconComponent from "../ProgressIconComponent/ProgressIconComponent";
import MapComponent from "../MapComponent/MapComponent";
import {formatMonthYear} from "../../Utils/date";


export default function SubSectionsCardsComponent({subSections, hideDelays}:{subSections: any, hideDelays: any}) {
    return (
        <Swiper
            // dir={'ltr'}
             modules={[A11y, Navigation]}
            navigation
            style={{ width: '100%', minHeight: '1px' }}
            centeredSlides={false}
            centerInsufficientSlides={true}
            spaceBetween={20}
            onSwiper={(swiper: any) => (swiper.current = swiper)}
            breakpoints={{
                320: {
                    slidesPerView: 1,
                },
                600: {
                    slidesPerView: 2,
                },
                1100: {
                    slidesPerView:3,
                },
                1450: {
                    slidesPerView:4,
                },
                1760: {
                    slidesPerView: 4,
                },
                1800: {
                    slidesPerView: 5,
                }
            }}>

            {subSections.map((subSection: any, index: number) => (
                <SwiperSlide key={index}>
                    <Box role = "button" tabIndex={0} sx={{bgcolor: '#FFFFFF', borderRadius: 2, p: 3}} dir="rtl">
                        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', mb: 2}}>
                            <Typography sx={{fontSize: 16, fontWeight: 700, color: '#0C3768', mb: 2}}>
                                {subSection.name}
                            </Typography>

                            <ProgressIconComponent data={subSection} fontSize={28} hideDelays={hideDelays} />
                        </Box>

                        {/*<MapComponent id={'map' + index} layerNumber={subSection.serial} />*/}

                        <Typography
                            sx={{fontSize: 14, fontWeight: 700, color: '#0C3768', textAlign: 'center', mt: 2}}>
                            תאריך סיום עדכני: {formatMonthYear(subSection.updated_end_date)}
                        </Typography>
                        <Typography sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#0C3768',
                            textAlign: 'center',
                            mb: 1
                        }}>
                            תאריך התחלה עדכני: {formatMonthYear(subSection.updated_start_date)}
                        </Typography>
                        <Typography
                            sx={{fontSize: 14, fontWeight: 400, color: '#0C3768', textAlign: 'center'}}>
                            תאריך סיום מקורי: {formatMonthYear(subSection.original_end_date)}
                        </Typography>
                        <Typography sx={{
                            fontSize: 14,
                            fontWeight: 400,
                            color: '#0C3768',
                            textAlign: 'center',
                            mb: 2
                        }}>
                            תאריך התחלה מקורי: {formatMonthYear(subSection.original_start_date)}
                        </Typography>
                    </Box>
                </SwiperSlide>
            ))}

        </Swiper>
    )
}
